import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WhatsappService {
  public baseUrl = environment.apiUrl;

  constructor(  public httpClient: HttpClient,
    public authService: AuthService,) { }

  InsertUpdateWhatsAppConfig(data:any){
    return this.httpClient.post(this.baseUrl + `WhatsAppConfig/InsertUpdateWhatsAppConfig`, data);
  }
  GetWhatsAppConfigByCompanyId(companyId:any){
    return this.httpClient.get(this.baseUrl + `WhatsAppConfig/${companyId}`);
  }
  GetCompanySettingsByCompanyId(companyId:any){
    return this.httpClient.get(this.baseUrl + `WhatsAppConfig/GetSystemSettingByCompanyId/${companyId}`);
  }
  GetContactByCompanyId(companyId:any){
    return this.httpClient.get(this.baseUrl + `WhatsAppConfig/contacts/${companyId}`);
  }
  GetChatHistory(companyId: any, phoneNumber: any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + `WhatsAppConfig/GetChatHistory/${companyId}/${phoneNumber}`);
  }
  SendWhatsappMessage(data:any){
    return this.httpClient.post(this.baseUrl + `WhatsAppConfig/SendMessage`, data);
  }
  CreateWhatsappTemplate(data:any){
    return this.httpClient.post(this.baseUrl + `WhatsAppConfig/CreateWhatsAppTemplate` ,data)
  }
  GetTemplateByCompanyId(companyId:any){
    return this.httpClient.get(this.baseUrl + `WhatsAppConfig/Templates/${companyId}`);
  }
  DeleteTemplate(companyId:any,name:any){
    return this.httpClient.delete(this.baseUrl + `WhatsAppConfig/MessageTemplate/${companyId}/${name}`)
  }
  UpdateTemplate(data:any){
    return this.httpClient.post(this.baseUrl + `WhatsAppConfig/UpdateTemplate` ,data)
  }
  uploadTemplateImage(data:any){
    return this.httpClient.post(this.baseUrl + `WhatsAppConfig/UploadWhatsappTemplateImage`, data);
  }
  BroadCastTemplate(data:any){
    return this.httpClient.post(this.baseUrl + `WhatsAppConfig/BroadCastTemplate`, data);
  }
  SaveTemplateAsDraft(data:any){
    return this.httpClient.post(this.baseUrl+ `WhatsAppConfig/SavetemplateAsDraft`, data);
  }
  GetDraftTemplateByCompanyId(companyId:any){
        return this.httpClient.get(this.baseUrl + `WhatsAppConfig/DraftTemplates/${companyId}`);
  }
}
